/**
 * Route wrapper: läser :category/:slug från URL, slår upp regel, renderar mall.
 */
import React from "react";
import { useParams, useLocation, Navigate } from "react-router-dom";
import { findRule } from "@/content/rulebank";
import RulePageTemplate from "@/components/rulebank/RulePageTemplate";

export default function RulePage() {
  const location = useLocation();
  const category = location.pathname.split("/").filter(Boolean)[0];
  const { slug } = useParams();
  const found = findRule(category, slug);
  if (!found) return <Navigate to={`/${category || ""}`} replace />;
  return <RulePageTemplate category={found.category} rule={found.rule} />;
}
